import { ProductCardLayoutType } from '../../common/models/product';
import { useIsSelected } from '../../single-choice/utils/selection';
import { CANCELLATION_OUTSIDE_EU } from '../../products';
import ProductLayout from '../../common/main-layout/ProductLayout';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { useProductData } from '../../common/hook/useProductData';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCELLATION_OUTSIDE_EU;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  title: 'cancellationOutsideEUTitle',
  persuasionContent: 'cancellationOutsideEUPersuasionContent',
  readMoreContent: 'cancellationOutsideEUReadMoreModalContent'
};
const mainCardTranslations = {
  ...sharedTexts,
  additionalInformation: 'cancellationOutsideEUAdditionalInformation',
  abstractContent: 'cancellationOutsideEUAbstract',
  upSell: 'cancellationOutsideEUUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'cancellationOutsideEUAbstractSmallCard',
    upSell: 'cancellationOutsideEUUpSellTextSmallCard'
  }
};
const CancellationOutsideEu = ({
  className,
  form,
  order,
  sellSpecification,
  productCode,
  productPosition,
  layoutType = MAIN_CARD_LAYOUT
}) => {
  const isSelected = useIsSelected(form, PRODUCT_NAME);
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    productId: PRODUCT_ID,
    order,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    isSelected,
    form,
    sellSpecification,
    className,
    texts,
    layoutType,
    productType: 'traveler'
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement
      });
  }
};
export default CancellationOutsideEu;
//# sourceMappingURL=CancellationOutsideEu.js.map